<template>
  <div>
    <template v-if="question.image == 0 && question.content == null">
      <b-row :key="answer.id" v-for="answer in question.answers">
        <b-col :cols=12 :md=12>
          <template v-if="editable">
            <!-- <b-form-input v-on:change="inputAnswer" placeholder="Enter your choice"></b-form-input> -->
            <!-- <b-form-select v-on:change="inputAnswer" class="mb-3">
                <b-form-select-option selected>Select your choice</b-form-select-option>
                <b-form-select-option v-for="select_item in question.selectOption" :key="select_item.index" :value="select_item.value">{{ select_item.value }}</b-form-select-option>
            </b-form-select> -->
            <span
              v-for="select_item in question.selectOption"
              :key="select_item.id"
              @click="inputAnswer2(select_item)"
            >
              <b-button
                pill
                variant="light"
                :class="'mx-1 btn__exam btn__exam--spell pl-3 pr-3' + ((inputAnswerSelect === select_item.value) ? ' btn__exam--selected' : '')"
              >
                <span>{{ select_item.value }}</span>
              </b-button>
            </span>
          </template>
          <template v-else>
            <b-form-input :state="Boolean(response && response.answer != null && answer.text_answer != null && response.answer.toUpperCase() == answer.text_answer.toUpperCase())" :value="response ? response.answer : ''" readonly></b-form-input>
          </template>
        </b-col>
        <template v-if="!editable">
          <b-col :cols=12 :md=12 class="mt-2">
            <template v-if="response && response.answer != null && answer.text_answer != null && response.answer.toLowerCase() != answer.text_answer.toLowerCase()">
              <b-form-input  :state="true" :value="answer.text_answer" readonly></b-form-input>
            </template>
          </b-col>
        </template>
      </b-row>
    </template>
  </div>
</template>

<script>
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'QuestionListeningAudio',
  props: {
    question: Object,
    editable: Boolean,
    response: Object
  },
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
      isSelected: false,
      inputAnswerSelect: null
    }
  },
  methods: {
    inputAnswer(evt) {
      this.$emit('selectAnswer', {
        question_id: this.question.id,
        answer: evt
      })
    },
    inputAnswer2(item) {
      this.inputAnswerSelect = item.value;
      console.log(this.question.id);
      console.log(item.value);
      this.$emit('selectAnswer', {
        question_id: this.question.id,
        answer: item.value
      });
    }
  }
}
</script>